<template>
    <div v-if="visible">
        <div class="popup-overlay" @click="onClose"></div>

        <div class="popup-wrapper" @click.stop>
            <div class="_pop_up_top_m" :style="mainBgStyle">
                <div class="_pop_up_close" @click="onClose">
                    <a href="javascript:void(0)"></a>
                </div>
            </div>

            <div class="_pop_up_mid_m" :style="mainBgStyle">
                <!--  @scroll="checkScrollBottom" -->
                <div class="_pop_up_txt" ref="content">
                    <slot></slot>
                </div>

                <div class="_pop_up_buttom_area">
                    <ul>
                        <li class="b-close h5">
<!--                            <a href="#">{{ lang($t('agree and continue')) }}</a>-->
<!--                            :disabled="!canAgree"-->
                            <button
                                @click="onAgree"
                                class="btn-like-li">
                                {{ lang($t('agree and continue')) }}
                            </button>
                        </li>
                        <li class="b-close2 h5" @click="onDisagree">
<!--                            <a href="#">{{ lang($t('disagree')) }}</a>-->
                            <button class="btn-like-li" >{{ lang($t('disagree')) }}</button>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="_pop_up_buttom_m" :style="mainBgStyle"></div>
        </div>
    </div>
</template>



<script>
import {common} from '@js/mixins/common'
export default {
    name: "ConsentDialog",
    mixins: [common],
    props: {
        visible: { type: Boolean, default: false },
        backgroundColor: { type: String, default: "#FFF" }
    },
    mounted() {
        window.addEventListener('resize', this.recomputeCanAgree)
    },

    beforeUnmount() {
        window.removeEventListener('resize', this.recomputeCanAgree)
    },

    data() {
        return {
            canAgree: false
        }
    },
    computed: {
        mainBgStyle() {
            return { backgroundColor: this.backgroundColor };
        },
    },
    watch: {
        visible(val) {
            if (val) {
                this.$nextTick(() => this.recomputeCanAgree())
            } else {
                this.canAgree = false
            }
            // if (val) {
            //     this.$nextTick(() => {
            //         const el = this.$el.querySelector('._pop_up_txt')
            //         if (!el) return
            //
            //         if (el.scrollHeight <= el.clientHeight) {
            //             this.canAgree = true
            //         }
            //     })
            // } else {
            //     this.canAgree = false
            // }
        }
    },
    methods: {
        onAgree() {
            // if (!this.canAgree) return
            this.$emit("agree")
        },
        onDisagree() {
            this.$emit("disagree")
        },
        onClose() {
            this.$emit("close")
        },
        recomputeCanAgree() {
            const el = this.$refs.content
            if (!el) return

            if (el.scrollHeight <= el.clientHeight) {
                this.canAgree = true
                return
            }

            this.canAgree =
                el.scrollTop + el.clientHeight >= el.scrollHeight - 5
        },
        checkScrollBottom() {
            this.recomputeCanAgree();
            // const el = e.target
            // const reachedBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 5
            // if (reachedBottom) {
            //     this.canAgree = true
            // }
        }
    }
}
</script>

<style scoped>
._element_to_pop_up_m {
    /*display:none;*/
    width: 60%;
    border-radius: 10px;
    box-shadow: 0px 2px 8px #000;
}
.popup_share object {
    width: 820px;
    overflow:hidden;
}
._pop_up_buttom_m {
    background-color: #FFF;
    height: 10px;
    width: 100%;
    display: block;
    border-radius: 0px 0px 10px 10px;
    float: left;
}
._pop_up_top_m {
    height: 50px;
    width: 100%;
    display: block;
    background-color: #FFF;
    border-radius: 10px 10px 0px 0px;
}
._pop_up_mid_m {
    background-color: #FFF;
    width: 100%;
    display: block;
    padding: 0px;
    float: left;
}
.pop_up_buttom_m {
    background-color: #FFF;
    height: 10px;
    width: 100%;
    display: block;
    border-radius: 0px 0px 10px 10px;
    float: left;
}
.pop_up_top_item {
    height: 120px;
    width: 860px;
    display: block;
    background-color: #FFF;
    border-radius: 10px 10px 0px 0px;
    border-bottom-width: 4px;
    border-bottom-style: solid;
    border-bottom-color: #ebc388;
}
._pop_up_txt{
    line-height: 2em;
    color: #666;
    padding-left: 30px;
    padding-right: 30px;
    height: 350px;
    overflow: auto;
    margin-bottom:20px;
}
._pop_up_txt ul{
    padding-inline-start: 20px;
}
._pop_up_txt ol{
    padding-inline-start: 20px;
}
._pop_up_buttom_area {
    width: 100%;
    padding: 0px;
    margin-top: 0px;
    margin-right: auto;
    margin-bottom: 0px;
    margin-left: auto;
}
._pop_up_buttom_area ul {
    list-style-type: none;
    margin: auto;
    width:60%;
    margin-bottom:20px;
    padding:0px;
}
._pop_up_buttom_area li {
    display:inline-block;
    width:100%;
}

.b-close.disabled {
    opacity: 0.4;
    pointer-events: none;
    cursor: not-allowed;
}

.b-close button {
    color: #FFF;
    background-color: #ffae00;
    transition: all 0.2s;
    border-radius: 30px;
    line-height: 2.2em;
    padding: 0px;
    margin: 5px;
    display:block;
    text-align:center;
}
.b-close button:hover {
    color: #ffae00;
    background-color: #FFF;
    transition: all 0.2s;
    box-shadow: 0px 2px 8px #959595;
    outline: 0;
}
.b-close2 button {
    color: #999;
    background-color: #EEE;
    transition: all 0.2s;
    border-radius: 30px;
    line-height: 2.2em;
    padding: 0px;
    margin: 5px;
    display:block;
    text-align:center;
}
.b-close2 button:hover {
    color: #999;
    background-color: #FFF;
    transition: all 0.2s;
    box-shadow: 0px 2px 8px #959595;
    outline: 0;
}
._pop_up_close {
    float: right;
    margin-top: 15px;
    margin-right: 10px;
    position: absolute;
    top: 0px;
    right: 0px;
}
._pop_up_close a {
    background-color: #ffae00;
    height: 26px;
    width: 26px;
    border-radius: 30px;
    background-image: url(../../image/icon/btn_on.png);
    background-repeat: no-repeat;
    display: block;
    background-position: 6px 6px;
}
._pop_up_close a:hover {
    background-color: #FFF;
    height: 26px;
    width: 26px;
    border-radius: 30px;
    background-image: url(../../image/icon/btn_close_on.png);
    background-repeat: no-repeat;
    display: block;
    background-position: 6px 6px;
    transition: all 0.2s;
    box-shadow: 0px 2px 8px #959595;
    outline: 0;
}

.popup-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 9998;
}

.popup-wrapper {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 60%;
    background: #FFF;
    border-radius: 10px;
    box-shadow: 0px 2px 8px #000;
    z-index: 9999;
}
.btn-like-li {
    all: unset;             /* 清除 button 的預設樣式 */
    display: block;
    width: 100%;
    height: 100%;
    cursor: pointer;
}

.btn-like-li:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/ConsentDialog.vue